import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import PersonOutlineRoundedIcon from '@material-ui/icons/PersonOutlineRounded';
import { apiList, verifyLogin } from '../../helpers';
import SectionCard from './SectionCard';

// Digits with an optional leading "+" (numbers are stored both as 10 digits
// and as +91XXXXXXXXXX).
const PHONE_PATTERN = /^\+?\d{0,12}$/;

export default function BasicDetails({ userDetails, onSaved }) {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({ ...userDetails });
  const [touched, setTouched] = useState(false);

  const firstNameMissing = !(profile.firstName || '').trim();
  const lastNameMissing = !(profile.lastName || '').trim();

  const setField = (field, value) => setProfile({ ...profile, [field]: value });

  const updateProfile = (event) => {
    event.preventDefault();
    setTouched(true);
    // hfcapi capitalises both names and fails on an empty one.
    if (firstNameMissing || lastNameMissing) {
      toast.error('First and last name are required.');
      return;
    }
    setLoading(true);
    const { session } = verifyLogin();
    const config = { headers: { session } };
    axios.post(`${apiList.UPDATE_PROFILE}`, profile, config)
      .then((response) => {
        setLoading(false);
        if (response) {
          toast.success('Profile Updated.');
          if (onSaved) onSaved(profile);
        }
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        setLoading(false);
      });
  };

  return (
    <form onSubmit={updateProfile} noValidate>
      <SectionCard
        Icon={PersonOutlineRoundedIcon}
        title='Personal details'
        subtitle='Your name and contact number as shown to your team.'
        footer={(
          <Button
            type='submit'
            variant='contained'
            color='primary'
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} color='inherit' /> : null}
          >
            {loading ? 'Saving…' : 'Save changes'}
          </Button>
        )}
      >
        <div className='form-grid'>
          <TextField
            id='firstName'
            label='First name'
            variant='outlined'
            fullWidth
            required
            value={profile.firstName || ''}
            error={touched && firstNameMissing}
            onChange={(e) => setField('firstName', e.target.value)}
          />
          <TextField
            id='lastName'
            label='Last name'
            variant='outlined'
            fullWidth
            required
            value={profile.lastName || ''}
            error={touched && lastNameMissing}
            onChange={(e) => setField('lastName', e.target.value)}
          />
          <TextField
            id='email'
            label='Email'
            variant='outlined'
            fullWidth
            disabled
            value={profile.email || ''}
            helperText='Managed by your administrator.'
          />
          <TextField
            id='mobile'
            label='Mobile number'
            variant='outlined'
            fullWidth
            type='tel'
            inputProps={{ inputMode: 'tel', autoComplete: 'tel' }}
            value={profile.alternateNumber || ''}
            onChange={(e) => {
              if (PHONE_PATTERN.test(e.target.value)) setField('alternateNumber', e.target.value);
            }}
          />
        </div>
      </SectionCard>
    </form>
  );
}
